module.exports = __webpack_public_path__ + "img/nvHai6.fb2cf105.png";